import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import axios from 'axios';
import { CheckCircleFilled } from '@ant-design/icons';

import { resolveLensUpdateRequest } from 'components/molecules/PPA/Modals/CustomLense/customLens.helpers';
import type {
    UpdateLensRequest,
    UpsertCustomLensResponse,
} from 'components/molecules/PPA/Modals/CustomLense/customLens.types';
import { ppaUrls } from 'config/urls';
import { createElement } from 'react';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';
import { sendNotification } from 'utils/helperMethods';

 
type UpdateLensVariables = {
    lensId: number;
    payload: UpdateLensRequest;
};

type UseUpdateLensResult = {
    loading: boolean;
    mutate: UseMutateFunction<UpsertCustomLensResponse, Error, UpdateLensVariables, unknown>;
};

export function useUpdateLens(): UseUpdateLensResult {
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async ({ lensId, payload }: UpdateLensVariables) => {
            const resolvedPayload = resolveLensUpdateRequest(lensId, payload);
            const response = await axios.put<UpsertCustomLensResponse>(
                ppaUrls.updateCustomLensUrl(lensId),
                resolvedPayload,
            );
            return response.data;
        },
        onSuccess: () => {
            notification.success({
                duration: 5,
                icon: createElement(CheckCircleFilled, {
                    style: { position: 'relative', top: -3, color: '#52C41A' },
                }),
                message: PricingSimulatorNotificationMessages.UPDATE_CUSTOM_LENS_SUCCESS_TITLE,
                description: PricingSimulatorNotificationMessages.UPDATE_CUSTOM_LENS_SUCCESS_DESCRIPTION,
                style: { width: 350, height: 'auto', borderRadius: 8 },
            });
        },
        onError: () => {
            sendNotification('error', PricingSimulatorNotificationMessages.LENS_CONFIG_FAILED);
        },
    });

    return {
        loading: isPending || isPaused,
        mutate,
    };
}

export default useUpdateLens;
